export const update = {
  updateSuccessfully: '洗濯機情報の変更に成功しました。',
}
